import React from 'react';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import useWorkflowPerms from '../components/workflow/useWorkflowPerms';
import { formatDateShort } from '../utils/dateFormat';
import NowName from '../components/shared/NowName';

// Engagement Registration — list page (docs/modules/workflow-engreg.md).
// THE project start: one request registers one or several same-group
// companies for one FYE; approval creates the engagements (Pending
// Acceptance) and the QC6/QC7 acceptance runs next.
const WorkflowEngReg = () => {
  const { canSubmit } = useWorkflowPerms('engreg');
  return (
    <WorkflowListShell
      title="Engagement Registration"
      subtitle="New engagement registrations."
      newTo="/workflow/engreg/new"
      canCreate={canSubmit}
      apiPath="/api/workflow/engreg"
      rowTo={(r) => `/workflow/engreg/${r.id}`}
      searchPlaceholder="Search request no, company, group or requester…"
      defaultSort={{ key: 'createdAt', direction: 'desc' }}
      columns={[
        { key: 'requestNo', label: 'Request', sortKey: 'requestNo', render: (r) => <span className="font-medium text-blue-700">{r.requestNo}</span> },
        { key: 'clientGroup', label: 'Client Group', sortKey: 'clientGroup', render: (r) => <NowName value={r.clientGroup} now={r.clientGroupNow} /> },
        {
          key: 'entities', label: 'Companies',
          render: (r) => (
            <span>
              <NowName value={r.entityNames} now={r.entityNamesNow} />
              {r.entityCount > 1 && (
                <span className="ml-1.5 inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-violet-50 text-violet-700">
                  {r.entityCount}
                </span>
              )}
            </span>
          ),
        },
        { key: 'yearEnd', label: 'FYE', sortKey: 'yearEnd', render: (r) => formatDateShort(r.yearEnd) },
        { key: 'partners', label: 'Partner', render: (r) => <NowName value={r.partnerNames} now={r.partnerNamesNow} /> },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => <WorkflowStatusBadge status={r.status} /> },
        { key: 'reviewer', label: 'Reviewer', sortKey: 'reviewer', className: 'whitespace-nowrap', render: (r) => <NowName value={r.reviewerName} now={r.reviewerNameNow} className="text-slate-600" /> },
        { key: 'requester', label: 'Requested By', render: (r) => <span className="text-slate-500">{r.requesterEmail}</span> },
      ]}
    />
  );
};

export default WorkflowEngReg;
